import { AiOutlineCopy, AiOutlineDelete, AiOutlineEdit } from 'react-icons/ai';
import dishImage from '../../../../../../assets/images/food-mock.png';
import { Card } from '../../../../../../components/card/card';
import { Checkbox } from '../../../../../../components/checkbox/checkbox';
import { IconButton } from '../../../../../../components/icon-button/icon-button';
import { DeleteModal } from '../../../../../../features/delete-modal/delete-modal';
import { HasAccess } from '../../../../../../features/has-access/has-access';
import {
  dishCategoryKey,
  dishCostKey,
  dishNameKey,
  dishPhotoKey,
  dishSectionKey,
} from '../../../../../../features/table/helpers';
import { Table } from '../../../../../../features/table/table';
import { TableFilterInput } from '../../../../../../features/table/table-filter/table-filter-input/table-filter-input';
import { TableFilterMultiSelect } from '../../../../../../features/table/table-filter/table-filter-multi-select/table-filter-multi-select';
import { TableFilterRange } from '../../../../../../features/table/table-filter/table-filter-range/table-filter-range';
import { TableFilterSingleSelect } from '../../../../../../features/table/table-filter/table-filter-single-select/table-filter-single-select';
import { useManagerStore } from '../../../../../../store/use-manager-store';
import { MenuInformerCopyDishModal } from './menu-informer-copy-dish-modal/menu-informer-copy-dish-modal';
import { MenuInformerCreateDishModal } from './menu-informer-create-dish-modal/menu-informer-create-dish-modal';
import { MenuInformerTableHeader } from './menu-informer-table-header/menu-informer-table-header';
import s from './menu-informer-table.module.css';
import { useMenuInformerTable } from './use-menu-informer-table';

export const MenuInformerMenuTable = () => {
  const {
    addQueryParams,
    copyDishModal,
    createDishModal,
    dishes,
    getLocale,
    isLoadingFetch,
    putDishStatus,
    selectedMenu,
    deleteDish,
    t,
  } = useMenuInformerTable();
  const { hasAccess } = useManagerStore();

  return (
    <Card>
      <Table
        id="menu-informer"
        columnSettings
        frontPagination
        className={s.table}
        isLoading={isLoadingFetch}
        header={{
          className: s.header,
          children: <MenuInformerTableHeader />,
        }}
        cols={{
          available: {
            label: t('Доступно к заказу'),
            filter: (
              <TableFilterSingleSelect
                name="available"
                options={[
                  { id: 'true', value: 'Да' },
                  { id: 'false', value: 'Нет' },
                ]}
              />
            ),
          },
          photo: {
            label: t('Изображение'),
            filter: (
              <TableFilterSingleSelect
                options={[
                  { id: 'true', value: 'С фото' },
                  { id: 'false', value: 'Без фото' },
                ]}
                name={dishPhotoKey}
              />
            ),
          },
          dishName: {
            label: t('Название'),
            filter: (
              <TableFilterInput
                name={dishNameKey}
                suggestOptions={dishes?.map((item) => getLocale(item.name))}
              />
            ),
          },
          category: {
            label: t('Категория'),
            filter: (
              <TableFilterMultiSelect
                options={selectedMenu?.categories?.map((item) => ({
                  id: String(item.id),
                  value: getLocale(item.name),
                }))}
                name={dishCategoryKey}
              />
            ),
          },
          section: {
            label: t('Раздел'),
            filter: (
              <TableFilterMultiSelect
                options={selectedMenu?.sections?.map((item) => ({
                  id: String(item.id),
                  value: getLocale(item.name),
                }))}
                name={dishSectionKey}
              />
            ),
          },
          cost: { label: t('Цена'), filter: <TableFilterRange name={dishCostKey} /> },
          actions: { label: t('Действия') },
        }}
        rows={dishes?.map((item) => ({
          available: (
            <Checkbox
              checked={item.is_on}
              onClick={() => putDishStatus(item.id, !item.is_on)}
              disabled={!hasAccess('menu', ['write'])}
            />
          ),
          photo: (
            <img
              src={item.images.main?.thumbnail || item.images.main?.normal || dishImage}
              alt={getLocale(item.name)}
              className={s.image}
            />
          ),
          dishName: getLocale(item.name),
          category: getLocale(
            selectedMenu?.categories?.find((category) => category.id === item.category_id)?.name,
          ),
          section: getLocale(
            selectedMenu?.sections?.find((section) => section.id === item.section_id)?.name,
          ),
          cost: item.prices.primary?.price,
          actions: (
            <HasAccess service="menu" permissions={['write']}>
              <div className={s.actions}>
                <IconButton
                  tooltip={t('Копировать')}
                  size="sm"
                  variant="secondary"
                  onClick={() => copyDishModal.handleOpenModal({ dishId: item.id })}
                >
                  <AiOutlineCopy />
                </IconButton>
                <IconButton
                  tooltip={t('Редактировать')}
                  size="sm"
                  variant="secondary"
                  onClick={() => createDishModal.handleOpenModal({ dishId: item.id })}
                >
                  <AiOutlineEdit />
                </IconButton>
                <IconButton
                  tooltip={t('Удалить')}
                  size="sm"
                  variant="secondary"
                  onClick={() =>
                    addQueryParams({
                      deleteId: item.id,
                      deleteName: getLocale(item.name),
                      deletePrefix: 'dish',
                    })
                  }
                >
                  <AiOutlineDelete />
                </IconButton>
              </div>
            </HasAccess>
          ),
        }))}
        onEmpty={{
          text: selectedMenu
            ? t('Добавьте блюдо, чтобы добавить его в меню')
            : t('Выберите или создайте меню'),
        }}
      />
      <HasAccess service="menu" permissions={['write']}>
        {createDishModal.isOpen && (
          <MenuInformerCreateDishModal
            onClose={() => createDishModal.handleCloseModal(['dishId'])}
          />
        )}
        {copyDishModal.isOpen && (
          <MenuInformerCopyDishModal onClose={() => copyDishModal.handleCloseModal(['dishId'])} />
        )}
        <DeleteModal onSubmit={deleteDish} prefix="dish" />
      </HasAccess>
    </Card>
  );
};
